var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 31.9687C25.0429 31.9688 31.9688 25.0429 31.9688 16.5C31.9688 7.95712 25.0429 1.03125 16.5 1.03125C7.95712 1.03125 1.03125 7.95712 1.03125 16.5C1.03125 25.0429 7.95712 31.9687 16.5 31.9687ZM13.8481 17.374V7.73437L19.1519 7.73438L19.1519 17.374H24.75L16.5 25.2656L8.25 17.374L13.8481 17.374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.1acd0fb60593d93d6e6b2a6dd25b1751.svg";
export { ForwardRef as ReactComponent };